export const PRODUCT_IDEA_KEYS = ['compare', 'soft-studio', 'architectural', 'product-detail', 'everyday-ritual'] as const;
export type ProductIdeaKey = typeof PRODUCT_IDEA_KEYS[number];
export const PRODUCT_IDEAS_PATH = '/guides/product-photography-ideas';

export function readProductIdea(value: string | null): ProductIdeaKey | null {
  return PRODUCT_IDEA_KEYS.find(key => key === value) ?? null;
}

export function buildProductIdeaHref(locale: import('@/i18n/locales').Locale, idea: ProductIdeaKey = 'compare'): string {
  return `/explore?${new URLSearchParams({ lang: locale, source_landing: PRODUCT_IDEAS_PATH, product_idea: idea })}`;
}

/** Incoming ideas must never replace the user's own unfinished work. */
export function canSeedProductIdeaDraft(
  consultation: { prompt: string; files: unknown[]; restoring: boolean },
  image: { draft: string; boundImages: unknown[]; isUploading: boolean; selectedCustomStyle: unknown; selectedSubjectModels: object },
  video: { draft: string; boundImages: unknown[]; isUploading: boolean },
): boolean {
  return !consultation.prompt.trim() && !consultation.files.length && !consultation.restoring
    && !image.draft.trim() && !image.boundImages.length && !image.isUploading
    && !image.selectedCustomStyle && !Object.values(image.selectedSubjectModels).some(Boolean)
    && !video.draft.trim() && !video.boundImages.length && !video.isUploading;
}
